var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoundedProtein(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.00012207,
    width: 40.0004,
    height: 40.0004,
    rx: 20.0002,
    fill: "#FEDEDD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2761 12.0862C19.6382 8.20414 23.4902 9.51715 23.5332 9.52915C23.5982 9.55415 23.6542 9.59915 23.6932 9.65815C24.0902 10.3642 24.3362 11.1482 24.4102 11.9542L24.4392 13.3272C24.2792 14.7812 23.7182 16.1623 22.8202 17.3183C22.9822 18.2643 22.9402 19.2333 22.6972 20.1603C22.4562 21.0873 22.0212 21.9533 21.4202 22.7013C21.3812 22.7514 21.3262 22.7874 21.2642 22.8064C21.2042 22.8264 21.1392 22.8264 21.0782 22.8084C21.0172 22.7914 20.9612 22.7564 20.9202 22.7074C20.8792 22.6594 20.8532 22.5994 20.8462 22.5364C20.7212 21.6734 20.3522 20.8623 19.7822 20.1993C18.4251 21.1323 16.9521 21.8864 15.4001 22.4424C15.5031 23.1584 15.4561 23.8884 15.2601 24.5864C15.0671 25.2844 14.7291 25.9334 14.2721 26.4944C14.2341 26.5364 14.1841 26.5664 14.1311 26.5844C14.0781 26.6024 14.0211 26.6054 13.9651 26.5934C13.9081 26.5844 13.8571 26.5614 13.8131 26.5264C13.7681 26.4904 13.7351 26.4444 13.7131 26.3924C13.5221 25.8024 12.9081 24.1694 12.3521 23.7264C11.793 23.2814 10.065 23.0464 9.43399 23.0004C9.37699 22.9924 9.32499 22.9694 9.28099 22.9344C9.23699 22.8984 9.20199 22.8524 9.18199 22.7994C9.15899 22.7464 9.151 22.6874 9.158 22.6294C9.165 22.5714 9.18899 22.5164 9.22499 22.4714C9.66799 21.8994 10.225 21.4254 10.862 21.0793C11.499 20.7343 12.198 20.5243 12.921 20.4653C12.962 20.1803 13.0011 19.8733 13.0561 19.5453L13.3551 18.0963C13.5561 17.2773 13.8141 16.4733 14.1261 15.6913C13.3551 15.2863 12.483 15.1092 11.616 15.1802C11.554 15.1872 11.489 15.1762 11.432 15.1452C11.375 15.1152 11.328 15.0703 11.299 15.0142C11.267 14.9582 11.254 14.8952 11.258 14.8312C11.264 14.7682 11.287 14.7073 11.326 14.6572C11.922 13.9022 12.671 13.2822 13.5231 12.8392C14.3791 12.3952 15.3171 12.1392 16.2761 12.0862Z",
    stroke: "#AF403B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.766 27.093C27.394 25.751 28.194 23.033 26.95 21.58C26.199 20.702 24.561 21.0541 24.364 22.1381C24.118 23.4961 23.331 24.4031 22.024 25.0791C21.045 25.5871 21.294 27.1021 22.608 27.6531",
    stroke: "#AF403B",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1392 24.1644C24.9182 24.6094 24.6492 24.8904 24.3542 25.1214",
    stroke: "#AF403B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5633 27.4244C30.5493 26.2694 29.0672 25.4884 28.2212 26.1944C27.1592 27.0774 25.9753 27.2694 24.5393 26.9494C23.4613 26.7114 22.6802 28.0334 23.3362 29.2984C25.0012 32.5034 30.5963 30.3674 30.5633 27.4244Z",
    stroke: "#AF403B",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5163 28.2455C27.0613 28.4465 26.6743 28.4885 26.3003 28.4755",
    stroke: "#AF403B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1 14.6671C21.355 14.6291 20.631 14.3532 20.038 13.8802C19.444 13.4072 19.014 12.7632 18.81 12.0452",
    stroke: "#AF403B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundedProtein);
export default __webpack_public_path__ + "static/media/rounded-protein.f36ede56e3235394bead7396587776e9.svg";
export { ForwardRef as ReactComponent };